// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsedActivityPreview-cls1___496b595b14a0d720cf3{/*!*/}.CollapsedActivityPreview-cls2__e3d73262912bda11ead6{margin:4px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsedActivityPreview-cls1___496b595b14a0d720cf3",
	"cls2": "CollapsedActivityPreview-cls2__e3d73262912bda11ead6 CollapsedActivityPreview-cls1___496b595b14a0d720cf3"
};
export default ___CSS_LOADER_EXPORT___;
